import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useModal, useProductQuery } from "_hooks";
import usePhototool from "../../usePhototool";
import { Button } from "components/atoms";
import Controls from "./Controls";
import Processing from "./Processing";
import Done from "./Done";
import { selectSkuSelected } from "_redux/ui/ui.selector";
import { fetchAllList } from "_redux/product/product.actions";
import { toggleRefresh } from "_redux/ui/ui.actions";
import { sleep } from "_utils/async";
import { chunk as _chunk } from "_utils/array";

let cancel = false;
const prefix = "mod-phototool-update-pc9-modal";

const UpdatePC9Modal = () => {
  const dispatch = useDispatch();
  const { closeModal } = useModal();

  const [current, setCurrent] = useState(0);
  const [data, setData] = useState();
  const [opt1, setOpt1] = useState(false);
  const [opt2, setOpt2] = useState(false);
  const [step, setStep] = useState(1);
  const [total, setTotal] = useState(1);
  const selections = useSelector(selectSkuSelected);

  const { getFromQuery } = useProductQuery();
  const { pc9Fetch } = usePhototool();
  const { t } = useTranslation();

  const sendRequest = async () => {
    let selection = Object.keys(selections.selected);
    
    if (selections.all) {
      let { w } = await getFromQuery();
      let response = await dispatch(fetchAllList({ w: w || {} }));
      selection = response?.data?.map((p) => p.key);
    } else if (selections.selected) {
      let response = await dispatch(fetchAllList({ w: { _id: selection } || {} }));
      selection = response?.data?.map((p) => p.key);
    }

    const chunk = _chunk(selection, 5);
    let success = 0;
    
    setTotal(selection?.length)
    setStep(2);

    let _current = 0;
    for (let i = 0; i < chunk.length; i++) {
      if (cancel) break;
      _current += chunk[i].length;
      let res = await sleep(200).then(() => {
        return pc9Fetch({
          pc9: { key: chunk[i] },
          opts: {
            getAssets: opt1,
            getInfo: opt2
          }
        }, { feedback: { error: false, success: false }});
      });

      setCurrent(_current);
      
      success = success + (res?.data?.[0]?.success?.withAssets ?? 0);
    }

    if (!cancel) {
      setData({ success, error: selection?.length - success });
      setStep(3);
    }
  };

  const element = () => {
    switch (step) {
      case 1:
        return <Controls 
        opt1={opt1}
        opt2={opt2}
        prefix={prefix}
        setOpt1={setOpt1}
        setOpt2={setOpt2}
        />
      case 2:
        return <Processing
          prefix={prefix}
          itemCurrent={current}
          itemTotal={total}
          current={(current / total) * 5}
          total={5}
        />
      case 3:
        return <Done
          data={data}
          prefix={prefix}
        />
      default:
        return null;
    }
  };

  return (
    <div className={prefix}>
      {element()}

      <div className={`${prefix}__buttons`}>
        
        <Button
          disabled={step === 3}
          content={t("common:form.cancel")}
          onClick={() => {
            cancel = true;
            closeModal();
          }}
          type="underline"
        />
        
        
        {step === 1 &&
          <Button
            content={t("common:words.continue")}
            disabled={(!selections?.all && !Object.keys(selections?.selected).length) || (!opt1 && !opt2) }
            sm
            type="purple"
            onClick={() => sendRequest()}
          />
        }

        {step === 3 &&
          <Button
            content={t("common:words.close")}
            sm
            type="purple"
            onClick={() => {
              closeModal();
              dispatch(toggleRefresh("products"));
            }}
          />
        }

      </div>
    </div>
  );
};

export default UpdatePC9Modal;
